import React from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import { Asset, Link } from "../../../../plugins/gatsby-plugin-atollon"
import { RightArrow } from "../../icons"

const ImageIconContent = ({ image, icon, title, link }) => {
  return (
    <section className="image-icon-content">
      <div className="image-icon-content__inner">
        {image && (
          <div className="image-icon-content__image" data-sal="slide-up" data-sal-duration="1000" data-sal-easing="ease">
            <Asset asset={image} />
          </div>
        )}

        <div className="image-icon-content__body" data-sal="slide-up" data-sal-duration="1000" data-sal-easing="ease">
          {icon && (
            <div className="image-icon-content__icon">
              <Asset asset={icon} />
            </div>
          )}

          {title && <h3>{parse(title)}</h3>}

          {link?.length > 0 && (
            <ul className="image-icon-content__links">
              {link.map((el, i) => (
                <li key={i}>
                  <Link
                    to={
                      el.link?.[0]?.externalLink
                        ? el.link[0].externalLink
                        : el.link?.[0]?.internalLink?.permalink
                    }
                  >
                    {el.title}
                    <RightArrow color="#0D2E7A" />
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </section>
  )
}

export default ImageIconContent

export const query = graphql`
  fragment ImageIconContentProps on DatoCmsImageIconContent {
    ... on DatoCmsImageIconContent {
      id
      title
      image {
        ...InternalAssetProps
      }
      icon {
        ...InternalAssetProps
      }
      link {
        ...LinkWithTitleProps
      }
    }
  }
`
